import { Routes } from '@angular/router';

export const preferredPharmacyRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./preferred-pharmacy.page').then((m) => m.PreferredPharmacyPage),
  },
  {
    path: 'search',
    loadComponent: () => import('./pages/pharmacy-search/pharmacy-search.page').then((m) => m.PharmacySearchPage),
  },
  {
    path: 'search/preview',
    loadComponent: () => import('./pages/pharmacy-preview/pharmacy-preview.page').then((m) => m.PharmacyPreviewPage),
  },
];
